import { Article, ArticleId } from '../types/app.types';

export const getInitialArticlesState = (): Map<ArticleId, Article> => {
  return new Map();
};
